import { useRef } from "react";

import { Button, FieldText, Flex, Select } from "@theorgchartdev/storybook";
import { RulePairInput } from "../RulePairInput/RulePairInput";
import { appstr } from "@coreapp/utils/appstr";

export const BuildRuleComparisonOptions = clickHandler => {
  // From QChartTemplateEditor line 1503
  const nameList = [{ label: "and" }, { label: "or", divider: true }, { label: "None" }];

  const options = [];
  for (const { label, divider } of nameList) {
    options.push({
      clickHandler,
      label: appstr(label),
      value: label,
      divider
    });
  }

  return options;
};

/**
 * type Props = {
 *   editing: boolean;
 *   rule: QRule;
 *   setRule: Dispatch<SetStateAction<QRule>>
 * }
 */
export const BasicRuleInput = props => {
  const ruleRef = useRef();
  ruleRef.current = props.rule;

  const handleUpdate = idx => rulePair => {
    const rule = ruleRef.current.Clone();
    rule.fRulePairList[idx] = rulePair;
    props.setRule(rule);
  };

  const handleRuleComparisonUpdate = ({ value }) => {
    const rule = props.rule.Clone();

    if (value === "None") {
      rule.RemoveIndexRulePair(1);
    } else {
      rule.SetLogicalOperator(value);
    }

    props.setRule(rule);
  };

  const handleAddRulePair = () => {
    const rule = props.rule.Clone();
    rule.AddRulePair("", "", "", "equals", "");
    rule.SetLogicalOperator("and");
    props.setRule(rule);
  };

  const firstPair = props.rule.GetIndexRulePair(0);
  const secondPair = props.rule.GetIndexRulePair(1);

  const commonRuleProps = {
    allowHierarchyFields: props.allowHierarchyFields ?? true,
    editing: props.editing,
    requiredMarker: props.requiredMarker,
    ...(props.rulePairProps ?? {})
  };

  const fieldErrors = props.errorsObject?.fieldError ?? {};
  const valueErrors = props.errorsObject?.valueError ?? {};
  const generalErrors = props.errorsObject?.generalRuleError ?? {};

  const renderGeneralError = index =>
    generalErrors[index]?.hasError ? (
      <span className="ocn-form-input-message ocn-form-input-message--error" role="alert">
        {generalErrors[index].errorString}
      </span>
    ) : null;

  return (
    <Flex direction="column" gap="16px">
      {firstPair ? (
        <>
          <RulePairInput
            {...commonRuleProps}
            fieldError={fieldErrors[0]}
            valueError={valueErrors[0]}
            value={firstPair}
            onChange={handleUpdate(0)}
            chartData={props.chartData}
          />
          {renderGeneralError(0)}
        </>
      ) : null}
      {secondPair ? (
        <>
          <Flex direction="row" width="30%" gap={"4px"}>
            {props.editing ? (
              <Select
                listWidth="fill"
                optionSize={"small"}
                options={BuildRuleComparisonOptions(handleRuleComparisonUpdate)}
                value={props.rule.GetLogicalOperator()}
              />
            ) : (
              <FieldText field="Comparison" value={props.rule.GetLogicalOperator()} />
            )}
          </Flex>
          <RulePairInput
            {...commonRuleProps}
            fieldError={fieldErrors[1]}
            valueError={valueErrors[1]}
            value={secondPair}
            onChange={handleUpdate(1)}
            chartData={props.chartData}
          />
          {renderGeneralError(1)}
        </>
      ) : (
        <Flex direction="row">
          {props.editing ? (
            <Button
              modifier={"secondary"}
              size={"small"}
              iconProps={{
                name: "plus-solid"
              }}
              onClick={handleAddRulePair}
            >
              {appstr("Create rule comparison")}
            </Button>
          ) : null}
        </Flex>
      )}
    </Flex>
  );
};
